<form [formGroup]="profilerReportingForm" autocomplete="off">
  <div class="form-controls-padding" style="margin-top: 10px">
    <!-- <div style="margin-bottom: 10px">
    You are currently generating a report for “{{ selectedShape.name }}” in
    "{{ selectedLocationData.name }}”
  </div> -->
    <div>
      <mat-form-field appearance="outline" hideRequiredMarker="true">
        <mat-label i18n="@@reportNamesLabel">Report names</mat-label>
        <input
          matInput
          type="text"
          formControlName="filter"
          placeholder="Search reports"
          (keyup)="onFilterChanged($event)"
          i18n-placeholder="@@searchReportsPlaceholder"
        />
        <mat-icon class="search-icon-wrapper" matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    <div>
      <div class="reports-label" i18n="@@reportsLabel">Reports</div>
      <div class="scrollable-list">
        <!-- If no reports have a report group assigned, display a flat list without grouping -->
        @if (
          groupedDataSource.length === 1 && !groupedDataSource[0].groupName
        ) {
          @for (pbiReport of groupedDataSource[0].reports; track pbiReport) {
            <div
              class="report-option"
              [class.selected-report]="selectedReport === pbiReport"
              (click)="onSelectionChange(pbiReport)"
            >
              <div class="report-name">{{ pbiReport.name }}</div>
              <div class="report-description">
                {{ pbiReport.description }}
              </div>
            </div>
          }
        } @else {
          <!-- Display reports grouped by report group -->
          <mat-accordion multi>
            @for (group of groupedDataSource; track group.groupName) {
              <mat-expansion-panel class="report-group-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span class="group-title">{{
                      group.groupName | titlecase
                    }}</span>
                  </mat-panel-title>

                  <span class="report-count">
                    {{ group.reports.length }}
                  </span>
                </mat-expansion-panel-header>

                @for (pbiReport of group.reports; track pbiReport) {
                  <div
                    class="report-option"
                    [class.selected-report]="selectedReport === pbiReport"
                    (click)="onSelectionChange(pbiReport)"
                  >
                    <div class="report-name">{{ pbiReport.name }}</div>
                    <div class="report-description">
                      {{ pbiReport.description }}
                    </div>
                  </div>
                }
              </mat-expansion-panel>
            }
          </mat-accordion>
        }
      </div>
    </div>
  </div>
</form>
